import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_GOOGLE_AUTH = createFcmDetails('google_auth', {
	owner: 'Site Platform',
	context: 'Login / Sign up',
	description: 'If true, a Google Auth button will be displayed on the login/signup pages and modals.',
	import: false,
});
